import { useMemo, useState } from "react";

/* Zuordnung — ARENA edition. Two glowing columns, selected card levitates in
   the accent colour, matches lock with a satisfying pop. Touch-first (no drag).
   Calls onFinish({correct,total}) where accuracy reflects wrong attempts. */
export default function Zuordnung({ module, accent = "#8b5cf6", onFinish }) {
  const pairs = module.pairs || [];
  const total = pairs.length;

  const left  = useMemo(() => pairs.map((p, i) => ({ id: i, t: p.a })).sort(() => Math.random() - 0.5), [module.id]); // eslint-disable-line
  const right = useMemo(() => pairs.map((p, i) => ({ id: i, t: p.b })).sort(() => Math.random() - 0.5), [module.id]); // eslint-disable-line

  const [selL, setSelL] = useState(null);
  const [matched, setMatched] = useState({});
  const [wrong, setWrong] = useState(0);
  const [shake, setShake] = useState(null);
  const [justHit, setJustHit] = useState(null);
  const done = Object.keys(matched).length;

  const tapRight = (rid) => {
    if (selL === null || matched[rid]) return;
    if (rid === selL) {
      const nm = { ...matched, [rid]: true };
      setMatched(nm); setSelL(null); setJustHit(rid);
      setTimeout(() => setJustHit(null), 500);
      if (Object.keys(nm).length === total) {
        const correct = Math.max(0, total - wrong);
        setTimeout(() => onFinish({ correct, total }), 500);
      }
    } else {
      setWrong((w) => w + 1); setShake(rid);
      setTimeout(() => setShake(null), 420);
    }
  };

  const cardBase = "rounded-2xl border px-4 py-4 text-center text-base font-black transition-all sm:text-lg";

  return (
    <div className="mx-auto w-full max-w-3xl">
      <div className="mb-2 flex items-center justify-between">
        <span className="rounded-full px-2.5 py-1 text-[10px] font-black uppercase tracking-widest" style={{ background: `${accent}1c`, color: accent, border: `1px solid ${accent}40` }}>
          Zuordnen
        </span>
        <div className="flex items-center gap-2">
          <div className="h-2 w-28 overflow-hidden rounded-full bg-white/10">
            <div className="h-full rounded-full transition-all duration-500" style={{ width: `${(done / total) * 100}%`, background: `linear-gradient(90deg, ${accent}, #22c55e)`, boxShadow: `0 0 10px ${accent}70` }} />
          </div>
          <span className="text-xs font-black text-white/55">{done}/{total}</span>
        </div>
      </div>
      {module.prompt && <p className="mb-4 text-base font-bold text-white/80">{module.prompt}</p>}

      <div className="grid grid-cols-2 gap-4 sm:gap-6">
        <div className="grid content-start gap-3">
          {left.map((c) => {
            const isMatched = matched[c.id];
            const isSel = selL === c.id;
            return (
              <button key={c.id} disabled={isMatched} onClick={() => setSelL(isSel ? null : c.id)}
                className={cardBase}
                style={isMatched
                  ? { borderColor: "rgba(34,197,94,0.45)", background: "rgba(34,197,94,0.12)", color: "rgba(74,222,128,0.6)", textDecoration: "line-through" }
                  : isSel
                    ? { borderColor: accent, background: `${accent}28`, color: "#fff", transform: "translateY(-4px) scale(1.03)", boxShadow: `0 0 26px ${accent}55, 0 10px 22px rgba(0,0,0,0.4)` }
                    : { borderColor: "rgba(255,255,255,0.12)", background: "rgba(255,255,255,0.045)", color: "#fff" }}>
                {c.t}
              </button>
            );
          })}
        </div>
        <div className="grid content-start gap-3">
          {right.map((c) => {
            const isMatched = matched[c.id];
            return (
              <button key={c.id} disabled={isMatched} onClick={() => tapRight(c.id)}
                className={cardBase}
                style={{
                  ...(isMatched
                    ? { borderColor: "rgba(34,197,94,0.45)", background: "rgba(34,197,94,0.12)", color: "rgba(74,222,128,0.75)" }
                    : shake === c.id
                      ? { borderColor: "#ef4444", background: "rgba(239,68,68,0.2)", color: "#fff" }
                      : { borderColor: "rgba(255,255,255,0.12)", background: "rgba(255,255,255,0.045)", color: "#fff" }),
                  ...(shake === c.id ? { animation: "sx-shake 0.4s" } : {}),
                  ...(justHit === c.id ? { animation: "sx-pop 0.45s both" } : {}),
                }}>
                {c.t}
              </button>
            );
          })}
        </div>
      </div>

      <p className="mt-5 text-center text-xs font-bold text-white/40">Tippe links ein Kärtchen, dann seinen Partner rechts. {wrong > 0 && `· ${wrong} Fehlversuche`}</p>
    </div>
  );
}
